import * as React from 'react';
import { ButtonStyles } from '@doltech/ui/lib/figma/Button/ButtonStyles/ButtonStyles';
import { ButtonSize } from '@doltech/ui/lib/figma/Button/ButtonSize/ButtonSize';
import { ButtonContentGeneral } from '@doltech/ui/lib/figma/Button/ButtonContentGeneral/ButtonContentGeneral';
import { IconSystemV2LogoFacebook2 } from '@doltech/icons/SystemV2/IconSystemV2LogoFacebook2';
import { DolFacebookShareButton } from '@doltech/ui/lib/figma/Social/DolFacebookShareButton';
import { ButtonIconPrimaryStyles } from '@doltech/ui/lib/figma/Button/ButtonIconPrimaryStyles/ButtonIconPrimaryStyles';
import { ButtonIconPrimarySize } from '@doltech/ui/lib/figma/Button/ButtonIconPrimarySize/ButtonIconPrimarySize';
import styled from 'styled-components';

const Wrapper = styled.div`
  .btn-text {
    font-weight: 500;
  }
`;

interface FacebookShareButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  pageId?: string;
  currentUrl?: string;
  hasText?: boolean;
}

export const FacebookShareButton = (props: FacebookShareButtonProps) => {
  const { pageId, currentUrl, hasText } = props;

  if (hasText) {
    return (
      <Wrapper>
        <DolFacebookShareButton
          pageId={pageId}
          className="facebook-share-button"
          key="facebook-share"
          url={currentUrl}
        >
          <ButtonStyles
            color="light"
            transparent
            content={
              <ButtonSize
                size="x-small"
                verticalPadding
                content={
                  <ButtonContentGeneral
                    btnStyle="icon"
                    text="Share"
                    withLeftIcon
                    iconLeft={<IconSystemV2LogoFacebook2/>}
                  />
                }
              />
            }
          />
        </DolFacebookShareButton>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <DolFacebookShareButton
        pageId={pageId}
        className="facebook-share-button"
        key="facebook-share"
        url={currentUrl}
      >
        <ButtonIconPrimaryStyles
          color="white"
          colorStyle="matte"
          transparent
          content={
            <ButtonIconPrimarySize size="medium" icon={<IconSystemV2LogoFacebook2/>}/>
          }
        />
      </DolFacebookShareButton>
    </Wrapper>
  );
};
